import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class GeoObjectModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (GeoObjectModel._instance == null) GeoObjectModel._instance = new GeoObjectModel(authManager);
        return GeoObjectModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'model-sections/geo-objects');

        this.entityName = 'model-sections.GeoObject';
        this.privileges = {
            create: [["adminGeotechData"],["manageGeotechData"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"]],
            delete: [["adminGeotechData"],["manageGeotechData"]],
        };

        this.label = 'Object';
        this.setLabel = 'Objects';

        this.browser = {
            name: 'default-model-sections-geoobject-browser',
            moduleName: 'default-model-sections-geoobject-browser',
            moduleTitle: 'Objects',
            moduleStateSlotName: 'default-model-sections-geoobject-browser',
        };

        this.editor = {
            name: 'default-model-sections-geoobject-editor',
            moduleName: 'default-model-sections-geoobject-editor',
            moduleTitle: 'Object',
            moduleStateSlotName: 'default-model-sections-geoobject-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                description: '(zajistit jedinečnost v rámci Code/Standard/Project)',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'modelSectionId',
                type: 'ModelSection',
                persistent: true,
                label: 'Model Section',
                description: 'only for info (check)',
            },
            {
                name: 'geoSectionId',
                type: 'GeoSection',
                persistent: false,
                label: 'Geo Section',
                description: 'geoLayer odpovídá vždy jen jedné geoSection, n:1',
                readOnly: true,
            },
            {
                name: 'objectTypeId',
                type: 'GeoObjectType',
                persistent: true,
                label: 'Object Type',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'elevationTop',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Elevation Top',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'elevationBottom',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Elevation Bottom',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'thickness',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Thickness',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'elevationOfZeroDatumLevel',
                type: 'float',
                persistent: false,
                unit: 'masl',
                label: 'Elevation Of Zero Datum Level',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalLevelTop',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Vertical Level Top',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalLevelBottom',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Vertical Level Bottom',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
        ];

    }

}
